"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearbymapObjectKind = void 0;
var NearbymapObjectKind;
(function (NearbymapObjectKind) {
    NearbymapObjectKind[NearbymapObjectKind["MARKER"] = 0] = "MARKER";
    NearbymapObjectKind[NearbymapObjectKind["WINDOW"] = 1] = "WINDOW";
    NearbymapObjectKind[NearbymapObjectKind["PIN"] = 2] = "PIN";
    NearbymapObjectKind[NearbymapObjectKind["ROUTE"] = 3] = "ROUTE";
    NearbymapObjectKind[NearbymapObjectKind["PRICETAG"] = 4] = "PRICETAG";
})(NearbymapObjectKind = exports.NearbymapObjectKind || (exports.NearbymapObjectKind = {}));
